// ** React Imports
import { useParams } from "react-router-dom";

// ** Custom Filters
import { isValid as filterSexIsValid } from "hooks/filters/useFilterSexRankings";
import { isValid as filterPeriodIsValid } from "hooks/filters/useFilterPeriod";

// #####################################################

const useRankingsValidator = () => {
	// ** Odczytanie parametrów z adresu URL
	const params = useParams();

	const {
		rankingPeriod: filterPeriodParam = "today",
		sex: filterSexParam = null,
	} = params || {};

	const validParams = () => {
		return {
			rankingPeriod: filterPeriodIsValid(filterPeriodParam),
			sex: filterSexIsValid(filterSexParam),
		};
	};

	const containInvalidParam = () =>
		Object.values(validParams()).includes(false);

	// #####################################################

	return { containInvalidParam };
};

// #####################################################

export default useRankingsValidator;

// #####################################################
